<template>
  <KTCard data-cy="employee-profile-aside-menu">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <div class="symbol symbol-100">
        <img class="symbol-label" :src="userAvatar" alt="avatar" />
      </div>

      <div class="w-100 my-4">
        <div class="user-info-item font-weight-bolder font-size-h5 text-dark-75">
          {{ userFullName }}
        </div>

        <div class="user-info-item navi-text text-muted text-hover-primary">
          {{ userEmail }}
        </div>

        <div class="user-info-item text-muted mt-2">
          {{ userRole }}
        </div>
      </div>
    </div>

    <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
      <div class="navi-item mb-2">
        <b-link
          :to="profileEditRoute"
          :class="{ active: isEditProfileActive }"
          class="navi-link profile-link py-4"
        >
          <span class="navi-text font-size-lg text-center">
            {{ $t("component.quickUser.myProfile") }}
          </span>
        </b-link>
      </div>

      <div class="navi-item mb-2">
        <b-link
          :to="changePasswordRoute"
          :class="{ active: isChangePasswordActive }"
          class="navi-link profile-link py-4"
        >
          <span class="navi-text font-size-lg text-center">
            {{ $t("component.quickUser.changePassword") }}
          </span>
        </b-link>
      </div>
    </div>
  </KTCard>
</template>

<script>
import { mapGetters } from "vuex";
import KTCard from "@/components/card/KTCard";

export default {
  name: "EmployeeProfileAsideMenu",
  components: {
    KTCard,
  },

  computed: {
    ...mapGetters(["userFullName", "userEmail", "userRole"]),

    userAvatar() {
      return `${process.env.BASE_URL}media/users/default.jpg`;
    },

    profileEditRoute() {
      return { name: "EmployeeProfileEdit" };
    },

    changePasswordRoute() {
      return { name: "EmployeeChangePassword" };
    },

    isEditProfileActive() {
      return this.$route.name === "EmployeeProfileEdit";
    },

    isChangePasswordActive() {
      return this.$route.name === "EmployeeChangePassword";
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info-item {
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  text-overflow: ellipsis;
}
</style>
